import { ToastQueue } from '@adobe/react-spectrum';

const OPTIMISTIC_ERROR_TOAST_TIMEOUT_MS = 5000;

/**
 * Logs a failed optimistic/slideout update and shows the standard negative toast.
 * Extracted from SlideOutPanel/index.tsx (Part 1b modularisation).
 */
export function showOptimisticUpdateErrorToast(
  message: string,
  error?: unknown
): void {
  if (error) {
    console.error(message, error);
  } else {
    console.error(message);
  }
  ToastQueue.negative(message, { timeout: OPTIMISTIC_ERROR_TOAST_TIMEOUT_MS });
}
